import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox } from '@dixa/lib-shared-habla';
import { KeyboardKeyCombinations } from 'components/keyboard';
import { useCommands } from 'utils/commands';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppSelector } from 'utils/redux/useAppSelector';
/**
 * Represents the components for displaying a tooltip content with associated
 * keybindings of a command.
 */
export const CommandKeybindingsTooltipContent = (props) => {
    const { keybindings } = useCommands();
    const keyboardShortcuts = useAppSelector((state) => state.settings.personal.keyboardShortcuts);
    const { newKeybindings } = useFeatureFlag(['new-keybindings']);
    const tooltipKeybindings = keybindings[props.commandName];
    const showKeybindings = newKeybindings && keyboardShortcuts && tooltipKeybindings.length;
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", flexDirection: "column", gap: "200" }, { children: [props.children, showKeybindings && (_jsx(Box, Object.assign({ margin: "0 0 100" }, { children: _jsx(KeyboardKeyCombinations, { keyCombinations: tooltipKeybindings, variant: "simple" }) })))] })));
};
